import * as types from '../constants/ActionTypes'
import * as summaryEventTypes from '../constants/SummaryEventTypes'
import {GetInitialState} from './initialState'

export default function mainReducer(state = GetInitialState(), action) {

  var newState = Object.assign({}, state);

    switch (action.type) {

        case types.SELECT_PLAYER:
            var allPlayers = newState.HomeTeam.Players.concat(newState.AwayTeam.Players);

            for (var i = 0; i < allPlayers.length; i++) {
                if(allPlayers[i].Id == action.playerId){
                  allPlayers[i].Selected = action.select;
                  break;
                }
            }

            return newState;
            break;

        case types.SELECT_MANAGER:

            if(action.home) {
              newState.HomeTeam.manager.selected  = action.select;
            }
            else {
              newState.AwayTeam.manager.selected  = action.select;
            }
            return newState;
            break;

            case types.GET_GAME_JSON_SUCCESS:
                window.Json = action.json;
                window.gameLoaded = true;
                newState.jsonLoaded = true;
                InitStateFromJson(newState);
                return newState;

            case types.MOVE_TO_NEXT_EVENT:
                var Json = window.Json;
                if(state.currentEvent < window.Json.game.length){
                  let event = window.Json.game[state.currentEvent-1];
                  ProcessEvents(event, newState);
                  newState.currentEvent = state.currentEvent + 1;
                }
                newState.scene = null;
                return newState;
              break;

            case types.SET_GAME_SPEED:
                newState.gameSpeed = action.gameSpeed;            
                return newState;
              break;

              case types.MOVE_TO_START:
                newState.currentEvent = 1;
                return newState;
              break;
              case types.START_GAME:
                  newState = Object.assign({}, state, { paused: false });
                  return newState;
                break;
              case types.PAUSE_GAME:
                    newState = Object.assign({}, state, { paused: true });
                    return newState;
                break;

              case types.END_REPLAY:
                  newState.replay = null;
                  newState.gameSpeed = GetGameSpeedFromLocalStorage();
                break;

              case types.SPEED_UP_GAME:
                    if(newState.replay == null) {
                      newState = Object.assign({}, state, { gameSpeed: Number((state.gameSpeed - action.step).toFixed(1)) });
                      SaveGameSpeedToLocalStorage(newState.gameSpeed);
                    }
                    return newState;
                break;
              case types.SLOW_DOWN_GAME:
                    if(newState.replay == null) {      
                        newState = Object.assign({}, state, { gameSpeed: Number((state.gameSpeed + action.step).toFixed(1)) });
                        SaveGameSpeedToLocalStorage(newState.gameSpeed);
                    }
                    return newState;
                    break;
              case types.TOGGLE_SOUND:
                    newState.muted = !state.muted;
                    SaveItemToLocalStorage('muted', newState.muted);
                    return newState;
                    break;
              case types.MOVE_TO_MINUTE:
              case types.MOVE_TO_EVENT:
              case types.START_REPLAY:
                  let current = newState.currentEvent;
                  let paused = newState.paused;
                  newState.scene = null;
                  newState = GetInitialState();
                  newState.paused = paused;
                  InitStateFromJson(newState);
                  
                  if(action.type == types.START_REPLAY) {
                    newState.paused = false;
                    newState.replay = {
                      from: action.from
                    };
                    newState.currentEvent = action.from;
                    newState.gameSpeed = convertReplaySpeed(window.PitchSettings.ReplaySpeed);
                    //newState.gameSpeed = window.PitchSettings.ReplaySpeed;
                  }
                  
                  for (i = 0; i < window.Json.game.length; i++) {
                    if(action.minute != null && window.Json.game[i].minute >= action.minute ||
                      action.from != null && window.Json.game[i].num >= action.from ||
                      action.num != null && window.Json.game[i].num >= action.num){
                      newState.currentEvent = i+1;
                      return newState;
                    }
                    else {
                      ProcessEvents(window.Json.game[i], newState);
                    }
                  }
                  break;
              case types.SHOW_STATS_SELECTOR:
                      newState.statisticWindows.statsSelectorVisible = true;
                      return newState;
                    break;
              case types.CLOSE_STATS_SELECTOR:
                      newState.statisticWindows.statsSelectorVisible = false;
                      return newState;
                  break;
              case types.HIGHLIGHT_PLAYERS:
                      for (i = 0; i < newState.HomeTeam.Players.length; i++) {
                        if(action.playerIds.includes(newState.HomeTeam.Players[i].Id))
                          newState.HomeTeam.Players[i].HighLight(state.currentEvent, state.scene != null);
                      }
                      for (i = 0; i < newState.AwayTeam.Players.length; i++) {
                        if(action.playerIds.includes(newState.AwayTeam.Players[i].Id))
                          newState.AwayTeam.Players[i].HighLight(state.currentEvent, state.scene != null);
                      }
                      return newState;
                  break;
              case types.CHANGE_WINDOW_POSITION:
                      newState.statisticWindows[action.id].position = action.position;
                      SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
                      return newState;
                  break;
                case types.CHANGE_WINDOW_SIZE:
                  newState.statisticWindows[action.id].width = action.width;
                  newState.statisticWindows[action.id].height = action.height;
                  SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
                  return newState;
              break;
              case types.TOGGLE_CUT_DOWN_WINDOW:
                      newState.statisticWindows[action.id].is_cut_down = action.isCutDown;
                      SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
                      return newState;
                  break;
              case types.SHOW_STATS_WINDOW:
                      newState.statisticWindows[action.id].visible = true;
                      SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
                      return newState;
                  break;
              case types.CLOSE_STATS_WINDOW:
                      newState.statisticWindows[action.id].visible = false;
                      SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
                      return newState;
                  break;
              case types.TOGGLE_SETTINGS_WINDOW:
                      newState.showSettings = !state.showSettings;
                      return newState;
                  break;
              case types.TOGGLE_ABOUT_WINDOW:
                  newState.showAbout = !state.showAbout;
                  return newState;
              break;
              case types.TOGGLE_DONATE_WINDOW:
                  if(state.showAbout && !state.showDonate) 
                    newState.showAbout = false;
                  newState.showDonate = !state.showDonate;
                  return newState;
              break;
              case types.START_SCENE:
                      newState.scene = {
                        type: action.sceneType,
                        event: action.event
                      };
                      return newState;
                  break;
              case types.END_SCENE:
                      newState.scene = null;
                      return newState;
                  break;

              case types.SET_THEME:
                  newState.theme = action.id;
                  SaveItemToLocalStorage('theme', newState.theme);
                  return newState;
              break;

              case types.CONNECT_TO_CHAT:
                    newState.chat.userName = action.userName;
                    newState.chat.connected = true;
                    return newState;
                  break;
              case types.RECIEVE_MESSAGES:
                  newState.chat.messages = newState.messages.concat(action.messages);
                  return newState;
                break;
              case types.UPDATE_CHANNELS:
                  newState.chat.channels = action.channels;
                  return newState;
                break;
              case types.UPDATE_USERS:
                  newState.chat.users = action.users;
                  return newState;
                break;
              case types.CHANGE_CHANNEL:
                  newState.chat.selectedChannelId = action.id;
                  return newState;
                break;
        default:
            return state;
        }

        return newState;
    }

    function convertReplaySpeed(speed){
      return 60 - (speed - 20);
    }

    function InitTeam(home, state) {
      var json = window.Json;
      var team = home == "home" ? state.HomeTeam : state.AwayTeam;
      var jsonTeam = home == "home" ? json.home.team : json.away.team ;
      var players = home == "home" ? state.HomeTeam.Players : state.AwayTeam.Players ;
      var jsonPlayers = home == "home"  ? json.home.players : json.away.players ;

      team.Flag = jsonTeam.flag;

      var colors = getTeamColors(jsonTeam);
      team.Back = colors.back;
      team.Color = colors.color;
      team.Border = colors.border;

      document.documentElement.style.setProperty(`--color-${home}`, colors.color);
      document.documentElement.style.setProperty(`--background-color-${home}`, colors.back);
      document.documentElement.style.setProperty(`--border-color-${home}`, colors.border);
      
      team.Name =  jsonTeam.name;
      team.form = jsonTeam.form;
      team.manager = {
        name: home == "home" ? json.home.manager : json.away.manager,
        selected: false
      }
      team.Formation = [];

      jsonPlayers.map(function(player, i){
          players[i]= {
            Id: parseInt(player.id),
            Name: {
              FirstName: '',
              LastName: player.name
            },
            Num: player.num,
            Number: player.number != null ? player.number : player.num,
            Selected: false,
            HighLighted: false,
            HighLightedFromEvent: 0,
            Injured: false,
            captain: player.captain,
            position: player.position,
            Stats: {
              Raiting: null,
              Conditions: null,
              Fatigue: 0,
              Goals: 0,
              Assists: 0
            },
            BenchSlot: i > 10 ? i - 10 : null,
            HighLight : function(eventNumber, isScene = false) {
              this.HighLighted = true;
              this.HighLightedFromEvent = eventNumber;
              if(!isScene) {
                setTimeout(() => { 
                  if(this.HighLightedFromEvent == eventNumber) {
                    this.HighLighted = false;
                  }
                }, 2500);
              }
            }
          };
      });
      for (var i=0;i<players.length;i++){
          team.Formation[i] = players[i].position;
      }
    }

    function getTeamColors(jsonTeam) {
      var data = require(`./teamColors.json`);
      var form = jsonTeam.form;

      var colorOverrides = null;
      for (var index = 0; index < data.length; index++) {
        var element = data[index];
        if(element.form == form)
          return element.colors;
      }

      return {
        back: jsonTeam.back.indexOf('#') == -1 ? '#' + jsonTeam.back : jsonTeam.back,
        color: jsonTeam.color.indexOf('#') == -1 ? '#' + jsonTeam.color : jsonTeam.color,
        border: jsonTeam.color.indexOf('#') == -1 ? '#' + jsonTeam.color : jsonTeam.color
      }
    }

    function InitWindowsState(state) {
      var windowsState = GetStatsWindowsStateToLocalStorage();
      if(windowsState != null)
        state.statisticWindows = windowsState;
    }

    function SaveStatsWindowsStateToLocalStorage(windowsState) {
      localStorage.setItem('windowsState', JSON.stringify(windowsState));
    }

    function GetStatsWindowsStateToLocalStorage() {
      var str = localStorage.getItem('windowsState');
      if(str == null || str == '')
        return null;
      var stats = JSON.parse(str);
      stats.statsSelectorVisible = false;
      if(stats.summary == null) {
        stats.summary = {
          visible: false,
          is_cut_down: false
        }
      }
      if(stats.chat == null) {
        stats.chat = {
          visible: false,
          is_cut_down: false
        }
      }
      if(stats.text == null) {
        stats.text = {
          visible: false,
          is_cut_down: false
        }
      }
      if(stats.pitch == null) {
        stats.pitch = {
          visible: false,
          is_cut_down: false
        }
      }
      if(stats.donate == null) {
        stats.donate = {
          visible: false,
          is_cut_down: false
        }
      }
      return stats;
    }

    function InitGameSpeedState(state) {
      let gameSpeed = GetItemFromLocalStorage('gameSpeed');
      if(gameSpeed != null)
        state.gameSpeed = gameSpeed;
    }

    function InitMutedState(state) {
      let muted = GetItemFromLocalStorage('muted');
      if(muted != null)
        state.muted = muted;
    }

    function InitThemeState(state) {
      let theme = GetItemFromLocalStorage('theme');
      if(theme != null)
        state.theme = theme;
    }

    function InitOnlineGames(state) {
      state.online_games.minute = 0;
      state.online_games.games = [];

      if(window.Json.online_games == null)
        return;

      window.Json.online_games.map(function(game, i){
        state.online_games.games.push({
          team1: game.team1,
          team2: game.team2,
          logo1: game.flag1,
          logo2: game.flag2,
          score: {
            home: 0,
            away: 0
          },
          goals1:[],
          goals2:[]
        })
      });
    }

    function SaveGameSpeedToLocalStorage(gameSpeed) {
      SaveItemToLocalStorage('gameSpeed', gameSpeed);
    }

    function SaveItemToLocalStorage(key, val) {
      localStorage.setItem(key, val);
    }

    function GetGameSpeedFromLocalStorage() {
      var str = localStorage.getItem('gameSpeed');
      if(str == null || str == '')
        return GetInitialState().gameSpeed;

      return parseInt(str);
    }

    function GetItemFromLocalStorage(item) {
      var str = localStorage.getItem(item);
      if(str == null || str == '')
        return GetInitialState()[item];

      if(str == 'true' || str == 'false')
        return str === 'true';

      return parseInt(str);
    }

    function InitStateFromJson(newState) {
      newState.halfTime = 0;
      InitTeam("home", newState);
      InitTeam("away", newState);
      ProcessFormAndRaiting(window.Json.game[0], newState);
      newState.weather = window.Json.weather;
      InitWindowsState(newState);
      InitGameSpeedState(newState)
      InitMutedState(newState)
      InitThemeState(newState)
      InitOnlineGames(newState)

      newState.jsonLoaded = window.gameLoaded == true;

      return newState;
    }

      function ProcessEvents(event, state) {
        if(event != null) {
          ProcessGoal(event, state);
          ProcessOwnGoal(event, state);
          ProcessShots(event, state);
          ProcessCaptainChange(event, state);
          ProcessSubstitutions(event, state);
          ProcessFormationChange(event, state)
          ProcessCards(event, state);
          ProcessCorners(event, state);
          ProcessFreeKicks(event, state);
          ProcessFouls(event, state);
          ProcessInjures(event, state);
          ProcessOffside(event, state);
          ProcessAddedTime(event, state);
          ProcessHalfTime(event, state);
          ProcessFormAndRaiting(event, state);
          ProcessPossession(event, state);
          ProcessPossessionOnlineGames(event, state);
        }
      }

    function ProcessGoal(event, state) {
      if(event.G != null){
        let teamState = event.G.team == 1 ?  state.HomeTeam : state.AwayTeam;
        if(event.G.team == 1){
          state.Stats.Score.Home = state.Stats.Score.Home + 1;
        }
        else {
          state.Stats.Score.Away = state.Stats.Score.Away + 1;
        }

        state.Stats.EventList.push({
          team: parseInt(event.G.team),
          minute: event.minute,
          event: event.num,
          playerId: GetPlayerByNum(teamState.Players, event.G.player).Id,
          assistId: event.G.assist != null && event.G.assist != 'P' && event.G.assist != 0 ? GetPlayerByNum(teamState.Players, event.G.assist).Id : null,
          penalty: event.G.assist == 'P',
          type: summaryEventTypes.Goal
        });

        GetPlayerByNum(teamState.Players, event.G.player).Stats.Goals++;
        if(event.G.assist != null && event.G.assist != '' && event.G.assist != 'P')
          GetPlayerByNum(teamState.Players, event.G.assist).Stats.Assists++;
      }
      if(event.GP != null) {
        let teamState = event.GP.team == 1 ?  state.HomeTeam : state.AwayTeam;
        if(event.GP.team == 1){
          state.Stats.Score.Home = state.Stats.Score.Home + 1;
        }
        else {
          state.Stats.Score.Away = state.Stats.Score.Away + 1;
        }
      }
    }

    function ProcessOwnGoal(event, state) {
      if(event.W != null) {
        let teamState = event.W.team == 1 ?  state.HomeTeam : state.AwayTeam;
        let otherTeamState = event.W.team == 1 ?  state.AwayTeam : state.HomeTeam;
        if(event.W.team == 1){
          state.Stats.Score.Home = state.Stats.Score.Home + 1;
        }
        else {
          state.Stats.Score.Away = state.Stats.Score.Away + 1;
        }

        state.Stats.EventList.push({
          team: parseInt(event.W.team),
          minute: event.minute,
          event: event.num,
          playerId: GetPlayerByNum(otherTeamState.Players, event.W.player).Id,
          assistId: null,
          penalty: false,
          type: summaryEventTypes.OwnGoal
        });
      }
    }

    function ProcessSubstitutions(event, state){
      if(event.S != null){
          let teamState = event.S.team == 1 ?  state.HomeTeam : state.AwayTeam;
          let res = GetPlayerWithIndexByNum(teamState.Players, event.S.out);
          let outPlayer = res.player;
          let outIndex = res.index;
          res = GetPlayerWithIndexByNum(teamState.Players, event.S.in);
          let inPlayer = res.player;
          let inIndex = res.index;

          teamState.Players[outIndex] = teamState.Players[inIndex];
          teamState.Players[inIndex] = outPlayer;

          teamState.Players[inIndex].Stats.SubOut = event.minute;
          teamState.Players[outIndex].Stats.SubIn = event.minute;

          outPlayer.BenchSlot = inPlayer.BenchSlot;
          inPlayer.BenchSlot = null;
      }
    }

    function ProcessFormationChange(event, state){
      if(event.ZT != null && event.ZT.positions.length > 0) {
        let teamState = event.ZT.team == 1 ?  state.HomeTeam : state.AwayTeam;
        teamState.Formation.length = 0;
        teamState.Formation = teamState.Formation.concat(event.ZT.positions);
      }
    }

    function ProcessHalfTime(event, state){
      if(event.M != null){
          state.sidesSwap++;
          if(state.sidesSwap == 2)
            state.timeAdded = null
      }
    }

    function ProcessFormAndRaiting(event, state){
      if(event.coordinates != null) {
        let home = event.coordinates.home;
        let away = event.coordinates.away;
        let homeStatePlayers = state.HomeTeam.Players;
        let awayStatePlayers = state.AwayTeam.Players;

        for (var index = 0; index < 11; index++) {
          if(home[index].f != null)
            homeStatePlayers[index].Stats.Conditions = home[index].f;
          if(home[index].m != null)  
            homeStatePlayers[index].Stats.Raiting = home[index].m / 100;
          if(home[index].c != null)  
            homeStatePlayers[index].Stats.Fatigue = home[index].c;
          
          if(away[index].f != null)
            awayStatePlayers[index].Stats.Conditions = away[index].f;
          if(away[index].m != null)
            awayStatePlayers[index].Stats.Raiting = away[index].m / 100;
          if(away[index].c != null)
            awayStatePlayers[index].Stats.Fatigue = away[index].c;
        }
      }
    }

    function ProcessPossessionOnlineGames(event, state) {
      if(state.online_games.minute < event.minute && window.Json.online_games != null) {
        for(let i = 0; i < window.Json.online_games.length; i++) {
          let goals =  window.Json.online_games[i].goals;
          let goal = getGoalsByMin(event.minute, goals);
          if(goal != null) {
            if(goal.team === 1) {
              state.online_games.games[i].score.home++;
              state.online_games.games[i].goals1.push({
                player: goal.player,
                min: goal.min
              })
            }
            else {
              state.online_games.games[i].score.away++;
              state.online_games.games[i].goals2.push({
                player: goal.player,
                min: goal.min
              })
            }
          }
        }
        
        state.online_games.minute = event.minute;
      }
    }

    function getGoalsByMin(minute, goals) {
      if(goals != null)
        for(let i = 0; i < goals.length; i++) {
          var goal = goals[i];
          if(parseInt(goal.min) === minute)
            return goal;
        }

      return null;
    }

    function ProcessPossession(event, state) {
      if(event.possession != null){
        state.Stats.Possession.Home = event.possession;
        state.Stats.Possession.Away = 100 - event.possession;
      }
    }

    function ProcessCards(event, state) {
      if(event.Y != null){
        let teamState = event.Y.team == 1 ?  state.HomeTeam : state.AwayTeam;
        GetPlayerByNum(teamState.Players, event.Y.player).Stats.HasYellowCard = true;
      }

      if(event.R != null){
        let teamState = event.R.team == 1 ?  state.HomeTeam : state.AwayTeam;
        let player = GetPlayerByNum(teamState.Players, event.R.player);
        player.Stats.HasRedCard = true;
        player.Stats.SubOut = event.minute;
        state.Stats.EventList.push({
          team: parseInt(event.R.team),
          minute: event.minute,
          event: event.num,
          playerId: player.Id,
          type: summaryEventTypes.RedCard
        });
      }
    }

      function ProcessCorners(event, state) {
        if(event.C != null){
          event.C.team == 1 ? (state.Stats.Corners.Home++) : (state.Stats.Corners.Away++);
        }
      }

      function ProcessOffside(event, state) {
        if(event.O != null){
          event.O.team == 1 ? (state.Stats.Offsides.Home++) : (state.Stats.Offsides.Away++);
        }
      }

      function ProcessShots(event, state) {
        if(event.U != null){
          switch(event.U.team) {
            case 1: 
              state.Stats.Shots.Home++;
              if(event.U.xg != null) {
                state.Stats.XG.Home += Number(event.U.xg);
                state.Stats.XG.Home = Math.round10(state.Stats.XG.Home,  -2); 
              }
              break;
            case 2: 
              state.Stats.Shots.Away++;
              if(event.U.xg != null) {
                state.Stats.XG.Away += Number(event.U.xg);
                state.Stats.XG.Away = Math.round10(state.Stats.XG.Away,  -2); 
              }
              break;
            case 3: 
              state.Stats.BlockedShots.Home++;
              break;
            case 4: 
              state.Stats.BlockedShots.Away++;
              break;
          }
        }
        if (event.V != null) {
           event.V.team == 1 ? (state.Stats.ShotsOnGoal.Home++) : (state.Stats.ShotsOnGoal.Away++);
        }
      }

      function ProcessFreeKicks(event, state) {
        if(event.F != null) {
          event.F.team == 1 ? (state.Stats.FreeKicks.Home++) : (state.Stats.FreeKicks.Away++);
        }

        if(event.E != null) {
          event.E.team == 1 ? (state.Stats.Penalty.Home++) : (state.Stats.Penalty.Away++);
        }
      }

      function ProcessFouls(event, state) {
        if(event.L != null) {
          event.L.team == 1 ? (state.Stats.Fouls.Home++) : (state.Stats.Fouls.Away++);
        }
      }

      function ProcessInjures(event, state) {
          if(event.I != null) {
            let teamState = event.I.team == 1 ?  state.HomeTeam : state.AwayTeam;
            GetPlayerByNum(teamState.Players, event.I.player).Injured = true;
          }
      }

      function ProcessCaptainChange(event, state) {
        if(event.K != null){
          let teamState = event.K.team == 1 ?  state.HomeTeam : state.AwayTeam;
          GetPlayerByNum(teamState.Players, event.K.player).captain = false;
          GetPlayerByNum(teamState.Players, event.K.player2).captain = true;
        }
      }

      function ProcessAddedTime(event, state) {
        if(event.D != null){
          state.timeAdded = event.D;
        }
      }

      export function GetPlayerWithIndexByNum(players, num) {
        for (let index = 0; index < players.length; index++) {
          let player = players[index];
          if(player.Num == num)
            return { player: player, index: index };
        }
        return null;
      }

      function GetPlayerByNum(players, num) {
        let res = GetPlayerWithIndexByNum(players, num);
        if(res != null)
          return res.player;

        return null;
      }


(function() {
  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // If the value is negative...
    if (value < 0) {
      return -decimalAdjust(type, -value, exp);
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }
  // Decimal floor
  if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
      return decimalAdjust('floor', value, exp);
    };
  }
  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }
})();


/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/